module.exports = __webpack_public_path__ + "static/media/typography_700x525.65c83bff.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/assets/typography_700x525.jpg
 ** module id = 165
 ** module chunks = 0
 **/